import { useState, useEffect } from "react";
import { GetUser } from "../../Services";
import Modal from "../../components/Modal";
import AddEditDispacher from "../../forms/dispacher";

function Dispatchers() {
  const [dispatchers, setDispatchers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingDispatcher, setEditingDispacher] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {

    fetchDispatchers();
  }, []);

      const fetchDispatchers = async () => {
      setLoading(true);
      try {
        const data = await GetUser.fetchDispatcherList();
        setDispatchers(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error fetching dispatcher:", error);
      } finally {
        setLoading(false);
      }
    };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to Deactivate this driver?")) return;
    try {
      await GetUser.deleteDispatcher(id);
      fetchDispatchers()
    } catch (error) {
      console.error("Error Deactivating driver:", error);
    }
  };

    const handleActivate = async (id) => {
    if (!window.confirm("Are you sure you want to Activate this driver?")) return;
    try {
      await GetUser.ActivateDispatcher(id);
      fetchDispatchers()
    } catch (error) {
      console.error("Error activating driver:", error);
    }
  };

  const handleEdit = (dispacher) => {
    console.log(dispacher);
    setEditingDispacher(dispacher);
    setShowModal(true);
  };
  return (
    <div className="content-wrapper">
      <div className="content-header">
        <h2 className="text-2xl font-bold">Dispatcher Management</h2>
      </div>

      <div className="card">
        <div className="card-header flex items-center justify-between">
          <button
            type="button"
            onClick={() => {
              setEditingDispacher(null);
              setShowModal(true);
            }}
            className="btn btn-primary btn-sm flex items-center"
          >
            <i className="fa fa-user mr-1"></i> Add Dispatchers
          </button>
        </div>

        <Modal showModal={showModal} setShowModal={setShowModal}>
          <AddEditDispacher
            editingDispatcher={editingDispatcher}
            setEditingDispacher={setEditingDispacher}
            setDispatchers={setDispatchers}
            setShowModal={setShowModal}
          />
        </Modal>

        <div className="card-body">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Role</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={6}>Loading dispatchers...</td>
                </tr>
              ) : dispatchers.length ? (
                dispatchers.map((dispatch) => (
                  <tr key={dispatch.id}>
                    <td>{dispatch.id}</td>
                    <td>{dispatch.name}</td>
                    <td>{dispatch.phone ?? "--"}</td>
                    <td>{dispatch.email}</td>
                    <td>{dispatch.role}</td>
                    <td>{dispatch.status?"Active":"Deactive"}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-primary mr-1"
                        onClick={() => handleEdit(dispatch)}
                      >
                        <i className="fas fa-edit"></i>
                      </button>
                      {dispatch.status ? (
                      <button
                        className="btn btn-sm btn-warning mr-1"
                        onClick={() => handleDelete(dispatch.id)}
                      >
                        <i className="fas fa-user-check"></i>
                      </button>
                      ):(
                      <button
                        className="btn btn-sm btn-success mr-1"
                        onClick={() => handleActivate(dispatch.id)}
                      >
                        <i className="fas fa-user-plus"></i>
                      </button>
                      )}
                     
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6}>No dispatcher found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="card-footer clearfix">
          <ul className="pagination pagination-sm m-0 float-right">
            <li className="page-item">
              <a
                className="page-link"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  if (currentPage > 1) handlePageChange(currentPage - 1);
                }}
              >
                &laquo;
              </a>
            </li>
            {[...Array(totalPages).keys()].map((page) => (
              <li
                className={`page-item ${
                  currentPage === page + 1 ? "active" : ""
                }`}
                key={page + 1}
              >
                <a
                  className="page-link"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handlePageChange(page + 1);
                  }}
                >
                  {page + 1}
                </a>
              </li>
            ))}
            <li className="page-item">
              <a
                className="page-link"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  if (currentPage < totalPages)
                    handlePageChange(currentPage + 1);
                }}
              >
                &raquo;
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Dispatchers;
